import { yen } from "../../lib/api";
import { useI18n } from "../../lib/i18n";

/** Rincian subtotal, biaya antar, diskon, dan total akhir. */
export const CartSummary = ({ totals, zone, city, settings, loyalty, promo }) => {
  const { t } = useI18n();
  const { subtotal, fee, loyaltyDiscount, grandTotal } = totals;
  const loyaltyPct = loyalty?.discount_pct || 0;

  return (
    <div className="border-t pt-3 space-y-1">
      <div className="flex justify-between items-center">
        <span className="text-sm text-muted-foreground">{t("subtotal")}</span>
        <span className="num text-sm" data-testid="online-subtotal">
          {yen(subtotal)}
        </span>
      </div>
      {fee > 0 && (
        <div className="flex justify-between items-center">
          <span className="text-sm text-muted-foreground">
            {t("delivery_fee_short")} (
            {zone === "outside"
              ? city || settings?.outside_area_label || t("zone_outside")
              : settings?.delivery_area || "Kumamoto shi"}
            )
          </span>
          <span className="num text-sm" data-testid="online-delivery-fee">
            {yen(fee)}
          </span>
        </div>
      )}
      {loyaltyPct > 0 && (
        <div className="flex justify-between items-center">
          <span className="text-sm text-primary">
            {t("loyalty_discount")} ({loyalty.tier} {loyaltyPct}%)
          </span>
          <span className="num text-sm text-primary" data-testid="loyalty-discount">
            -{yen(loyaltyDiscount)}
          </span>
        </div>
      )}
      {promo.discount > 0 && (
        <div className="flex justify-between items-center">
          <span className="text-sm text-primary">
            {t("promo_discount")} ({promo.code})
          </span>
          <span className="num text-sm text-primary" data-testid="promo-discount">
            -{yen(promo.discount)}
          </span>
        </div>
      )}
      <div className="flex justify-between items-center">
        <span className="font-display font-semibold">{t("total")}</span>
        <span className="num text-2xl font-semibold" data-testid="online-total">
          {yen(Math.max(grandTotal - loyaltyDiscount - promo.discount, 0))}
        </span>
      </div>
    </div>
  );
};
